import React from 'react';
import ReactDOM from 'react-dom';

interface PoliticaPrivacidadPopupProps {
  onClose: () => void;
}

const PoliticaPrivacidadPopup: React.FC<PoliticaPrivacidadPopupProps> = ({ onClose }) => {
  const popup = (
    <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.5)',
        zIndex: 999999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }}>
        <div style={{
            background: '#fff',
            borderRadius: 8,
            maxWidth: 600,
            width: '90%',
            padding: 24,
            boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
            position: 'relative',
        }}>
            <button onClick={onClose} style={{ position: 'absolute', top: 8, right: 8, background: 'none', border: 'none', fontSize: 20, cursor: 'pointer' }}>&times;</button>
            <h2>Política de Privacidad</h2>
            <p>
                Esta aplicación respeta y protege la privacidad de los usuarios. Los datos recolectados se utilizan únicamente para el funcionamiento y mejora del servicio, y no se comparten con terceros salvo obligación legal. Para más información, contacte al responsable del proyecto.
            </p>
            <p>
                Al utilizar esta aplicación, usted acepta los términos de esta política de privacidad.
            </p>
        </div>
    </div>
  );

  return ReactDOM.createPortal(popup, document.body);
};

export default PoliticaPrivacidadPopup;
